__webpack_require__.p = new Function("return window.__FEDERATION__.ssoPublicPath + \"/\"")()